import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { buildTabComponentRegistry } from '@core/dynamic-components/utils/build-tab-registry';

import { TabService } from './tab.service';
import { TabComponentType } from './types/tab-component.type';

@Component({
  selector: 'jb-tab-component-container',
  templateUrl: './tab-component.component.html',
  styleUrls: ['./tab-component.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabComponent implements OnInit {
  content: TabComponentType;
  displayIcons = false;

  constructor(private tabService: TabService) {}

  ngOnInit() {
    if (this.content) {
      this.displayIcons = this.content.tabbedNavigationComponent.every(
        item => !!item?.data?.icon?.length,
      );
    }
  }

  createRegistry(components) {
    return components ? buildTabComponentRegistry(components) : {};
  }

  onTabSelected(event: number) {
    this.tabService.selectTab(event);
  }
}

export const tabComponentResolver = (_, data) => {
  return {
    content: data || {},
  };
};
